import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import './opportunities.css';

const Opportunities = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const jobCategories = [
    { id: 'all', name: 'All Opportunities', icon: '🌟' },
    { id: 'tech', name: 'Technology', icon: '💻' },
    { id: 'warehouse', name: 'Warehouse & Logistics', icon: '📦' },
    { id: 'retail', name: 'Retail & Sales', icon: '🛍️' },
    { id: 'bursary', name: 'Bursaries', icon: '🎓' },
    { id: 'support', name: 'Customer Support', icon: '📞' }
  ];

  const opportunities = [
    {
      id: 1,
      title: 'Front-end Software Engineer',
      company: 'Enerstic Digital',
      location: 'Johannesburg, Gauteng',
      type: 'Full-time',
      category: 'tech',
      salary: 'R35,000 - R55,000 pm',
      requirements: [
        '3+ years experience with React.js',
        'Proficient in HTML5, CSS3, JavaScript ES6+',
        'Experience with state management (Redux/Context)',
        'Knowledge of responsive design principles',
        'Familiar with Git version control'
      ],
      description: 'Join our dynamic tech team to build cutting-edge e-commerce solutions. Work on modern React applications and contribute to our growing fashion platform.',
      deadline: '2024-02-15',
      icon: '⚛️'
    },
    {
      id: 2,
      title: 'Full Stack Developer',
      company: 'TechInnovate SA',
      location: 'Cape Town, Western Cape',
      type: 'Full-time',
      category: 'tech',
      salary: 'R40,000 - R65,000 pm',
      requirements: [
        '5+ years full-stack development',
        'Node.js, Express, MongoDB',
        'React/Vue.js experience',
        'REST API development',
        'AWS/Cloud deployment'
      ],
      description: 'Develop end-to-end solutions for our client projects. Opportunity to work on diverse projects across multiple industries.',
      deadline: '2024-02-28',
      icon: '🚀'
    },

    {
      id: 3,
      title: 'Warehouse Manager',
      company: 'Enerstic Logistics',
      location: 'Durban, KwaZulu-Natal',
      type: 'Full-time',
      category: 'warehouse',
      salary: 'R25,000 - R35,000 pm',
      requirements: [
        '5+ years warehouse management',
        'Inventory management systems',
        'Team leadership experience',
        'Health & Safety compliance',
        'Logistics coordination'
      ],
      description: 'Oversee our distribution center operations. Manage inventory, coordinate shipments, and lead our warehouse team.',
      deadline: '2024-02-20',
      icon: '🏭'
    },
    {
      id: 4,
      title: 'Packers & Assemblers',
      company: 'Enerstic Fashion',
      location: 'Pretoria, Gauteng',
      type: 'Full-time',
      category: 'warehouse',
      salary: 'R8,000 - R12,000 pm',
      requirements: [
        'Matric certificate',
        'Attention to detail',
        'Physical fitness for lifting',
        'Teamwork skills',
        'Reliable transportation'
      ],
      description: 'Join our packaging team to prepare fashion items for shipment. Great entry-level opportunity with growth potential.',
      deadline: '2024-02-10',
      icon: '📦'
    },

    {
      id: 5,
      title: 'Technical Support Specialist',
      company: 'Enerstic Support',
      location: 'Remote / Johannesburg',
      type: 'Full-time',
      category: 'support',
      salary: 'R15,000 - R22,000 pm',
      requirements: [
        '2+ years customer support',
        'Technical troubleshooting',
        'Excellent communication',
        'E-commerce platform knowledge',
        'Bilingual (English + Afrikaans/Zulu)'
      ],
      description: 'Provide technical support for our online platform. Help customers with orders, accounts, and technical issues.',
      deadline: '2024-02-25',
      icon: '🔧'
    },

    {
      id: 6,
      title: 'Retail Store Manager',
      company: 'Enerstic Boutique',
      location: 'Sandton, Gauteng',
      type: 'Full-time',
      category: 'retail',
      salary: 'R18,000 - R28,000 pm',
      requirements: [
        '3+ years retail management',
        'Sales target achievement',
        'Team training & development',
        'Inventory management',
        'Customer service excellence'
      ],
      description: 'Lead our flagship store team. Drive sales, manage operations, and deliver exceptional customer experiences.',
      deadline: '2024-03-01',
      icon: '👔'
    },

    {
      id: 7,
      title: 'Enerstic IT Bursary Programme',
      company: 'Enerstic Education Trust',
      location: 'Nationwide',
      type: 'Bursary',
      category: 'bursary',
      salary: 'Full tuition + R5,000 monthly allowance',
      requirements: [
        'South African citizen',
        'Under 25 years old',
        'Matric with 70%+ average',
        'Accepted into IT/Computer Science degree',
        'Household income < R350,000 pa'
      ],
      description: 'Full bursary for IT and Computer Science students. Includes tuition, books, and monthly living allowance.',
      deadline: '2024-03-15',
      icon: '🎓'
    },
    {
      id: 8,
      title: 'Fashion Design Bursary',
      company: 'Enerstic Creative Foundation',
      location: 'Nationwide',
      type: 'Bursary',
      category: 'bursary',
      salary: 'Tuition + Materials + Internship',
      requirements: [
        'Passion for fashion design',
        'Portfolio of creative work',
        'Matric certificate',
        'Accepted into fashion design program',
        'Financial need demonstrated'
      ],
      description: 'Comprehensive bursary for aspiring fashion designers. Includes internship opportunities at Enerstic.',
      deadline: '2024-03-20',
      icon: '👗'
    },
    {
      id: 9,
      title: 'Snops Bursary Support',
      company: 'Snops Capitals Bursary',
      location: 'Nationwide',
      type: 'Bursary',
      category: 'bursary',
      salary: 'Full funding available',
      requirements: [
        'South African citizen',
        'Financial need',
        'Academic acceptance',
        'Household income thresholds',
        'Academic performance'
      ],
      description: 'Assistance with Snops applications and additional support for qualifying students.',
      deadline: '2024-11-30',
      icon: '🏛️'
    }
  ];

  const filteredOpportunities = opportunities.filter(opportunity => {
    const matchesCategory = activeCategory === 'all' || opportunity.category === activeCategory;
    const matchesSearch = opportunity.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         opportunity.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         opportunity.location.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleApply = (opportunity) => {
    navigate('/apply', { 
      state: { 
        position: opportunity.title,
        company: opportunity.company 
      }
    });
  };

  const handleSaveOpportunity = (opportunity) => {
    const doc = new jsPDF();
    
    doc.setFillColor(38, 47, 217);
    doc.rect(0, 0, 210, 40, 'F');
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('ENERSTIC OPPORTUNITY', 105, 20, { align: 'center' });
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Job Opportunity Details', 20, 55);
    
    let yPosition = 70;
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    
    const details = [
      { label: 'Position:', value: opportunity.title },
      { label: 'Company:', value: opportunity.company },
      { label: 'Location:', value: opportunity.location },
      { label: 'Type:', value: opportunity.type },
      { label: 'Salary:', value: opportunity.salary },
      { label: 'Application Deadline:', value: opportunity.deadline }
    ];

    details.forEach(detail => {
      doc.text(`${detail.label} ${detail.value}`, 20, yPosition);
      yPosition += 7;
    });

    yPosition += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('Job Description:', 20, yPosition);
    yPosition += 7;
    doc.setFont('helvetica', 'normal');
    const descriptionLines = doc.splitTextToSize(opportunity.description, 170);
    doc.text(descriptionLines, 20, yPosition);
    yPosition += (descriptionLines.length * 5) + 10;

    doc.setFont('helvetica', 'bold');
    doc.text('Requirements:', 20, yPosition);
    yPosition += 7;
    doc.setFont('helvetica', 'normal');
    
    opportunity.requirements.forEach((requirement, index) => {
      const requirementLines = doc.splitTextToSize(`• ${requirement}`, 170);
      doc.text(requirementLines, 20, yPosition);
      yPosition += (requirementLines.length * 5) + 3;
    });

    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(`Saved from Enerstic Careers on: ${new Date().toLocaleDateString()}`, 20, 280);
    doc.text('Apply at: www.enerstic.co.za/careers', 20, 285);

    const fileName = `enerstic-opportunity-${opportunity.title.replace(/\s+/g, '-').toLowerCase()}.pdf`;
    doc.save(fileName);
    
    alert(`✅ Opportunity saved as PDF: ${fileName}`);
  };

  return (
    <div className="opportunities-page">
      <div className="opportunities-header">
        <h1>Career Opportunities & Bursaries</h1>
        <p>Join the Enerstic family or further your education with our support programmes</p>
      </div>

      <div className="opportunities-controls">
        <div className="search-container">
          <input
            type="text"
            placeholder="🔍 Search opportunities..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="category-filters">
          {jobCategories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              <span className="category-icon">{category.icon}</span>
              {category.name}
            </button>
          ))}
        </div>
      </div>

      <div className="opportunities-grid">
        {filteredOpportunities.length > 0 ? (
          filteredOpportunities.map(opportunity => (
            <div key={opportunity.id} className="opportunity-card">
              <div className="opportunity-header">
                <div className="opportunity-icon">{opportunity.icon}</div>
                <div className="opportunity-title-section">
                  <h3 className="opportunity-title">{opportunity.title}</h3>
                  <p className="opportunity-company">{opportunity.company}</p>
                </div>
                <span className={`opportunity-type ${opportunity.type.toLowerCase()}`}>
                  {opportunity.type}
                </span>
              </div>

              <div className="opportunity-details">
                <div className="detail-item">
                  <span className="detail-label">📍 Location:</span>
                  <span className="detail-value">{opportunity.location}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">💰 Package:</span>
                  <span className="detail-value">{opportunity.salary}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">⏰ Deadline:</span>
                  <span className="detail-value">{opportunity.deadline}</span>
                </div>
              </div>

              <div className="opportunity-description">
                <p>{opportunity.description}</p>
              </div>

              <div className="requirements-section">
                <h4>Requirements:</h4>
                <ul className="requirements-list">
                  {opportunity.requirements.map((requirement, index) => (
                    <li key={index}>{requirement}</li>
                  ))}
                </ul>
              </div>

              <div className="opportunity-actions">
                <button 
                  className="apply-btn"
                  onClick={() => handleApply(opportunity)}
                >
                  Apply Now
                </button>
                <button 
                  className="save-btn"
                  onClick={() => handleSaveOpportunity(opportunity)}
                >
                  📄 Save as PDF
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-results">
            <div className="no-results-icon">🔍</div>
            <h3>No opportunities found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      <div className="opportunities-info">
        <div className="info-card">
          <div className="info-icon">📧</div>
          <h3>How to Apply</h3>
          <p>Click "Apply Now" to fill out our online application form. You'll be able to submit your CV and supporting documents directly.</p>
        </div>

        <div className="info-card">
          <div className="info-icon">📋</div>
          <h3>Application Tips</h3>
          <p>Tailor your CV to the position, include a cover letter, and ensure all required documents are attached.</p>
        </div>

        <div className="info-card">
          <div className="info-icon">🎓</div>
          <h3>Bursary Support</h3>
          <p>Need help with your bursary application? Contact our education support team at bursaries@enerstic.co.za</p>
        </div>
      </div>
    </div>
  );
};

export default Opportunities;